import { AxiosResponse } from 'axios';
import {
  CopyDestinationLayoutListResponse,
  LayoutCopyRequest,
  LayoutEditListResponse,
  LayoutEditResponse,
  LayoutEntry,
  LayoutNameEntry,
  NewCreatedLayoutResponse,
  NewLayoutRequest,
} from 'types/entity';
import { LayoutListResponse } from 'types/entity/layout-list-response';
import { LayoutResponse } from 'types/entity/layout-response';
import { http } from './settings';

export const fetchLayouts = (projectId: string): Promise<LayoutResponse[]> => http.get(`/projects/${projectId}/layouts`)
  .then((value: AxiosResponse<LayoutListResponse>) => value.data.layouts || []);

export const fetchDefaultLayout = (projectId: string): Promise<LayoutResponse> => http.get(`/projects/${projectId}/layouts/working`)
  .then((value: AxiosResponse<LayoutResponse>) => value.data);

export const postDefaultLayout = (projectId: string, layoutId: string): Promise<LayoutResponse> => http.post(`/projects/${projectId}/layouts/${layoutId}/working`);

export const fetchAdminLayouts = (projectId: string): Promise<LayoutEditResponse[]> => http.get(`/admin/projects/${projectId}/layouts`)
  .then((value: AxiosResponse<LayoutEditListResponse>) => value.data.layouts || []);

export const putLayout = (projectId: string, layoutId: string, layout: LayoutEntry): Promise<void> => http.put(`/projects/${projectId}/layouts/${layoutId}`, layout);

export const postLayout = (projectId: string, newLayoutRequest: NewLayoutRequest): Promise<NewCreatedLayoutResponse> => http.post(`/projects/${projectId}/layouts`, newLayoutRequest)
  .then((value: AxiosResponse<NewCreatedLayoutResponse>) => value.data);

export const deleteLayout = (projectId: string, layoutId: string) => http.delete(`/projects/${projectId}/layouts/${layoutId}`);

export const putLayoutName = (projectId: string, layoutId: string, layoutNameEntry: LayoutNameEntry): Promise<void> => http.put(`/projects/${projectId}/layouts/${layoutId}/layoutName`, layoutNameEntry);

export const fetchCopyDestinationList = (projectId: string, layoutId: string): Promise<CopyDestinationLayoutListResponse> => http.get(`/projects/${projectId}/layouts/${layoutId}/copy_destination_layouts`)
  .then((value: AxiosResponse<CopyDestinationLayoutListResponse>) => value.data);

export const putLayoutCopyTo = (projectId: string, layoutId: string, body: LayoutCopyRequest): Promise<void> => http.put(`/projects/${projectId}/layouts/${layoutId}/copy_to`, body);
